/* eslint-disable max-len */
import { Routes, Route } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { type FinderApplicationEntrypointContextDataFragment } from '../../../api/fragments/FinderApplicationEntrypointContextData';
import hasPermissions from '../../../utilities/hasPermissions';
import withPrivateAccess from '../../../utilities/withPrivateAccess';
import { FinderApplicationProvider } from '../FinderApplicationPublicAccessEntrypoint/FinderApplicationContext';
import Journey from '../FinderApplicationPublicAccessEntrypoint/Journey';
import OfferPage from '../FinderApplicationPublicAccessEntrypoint/OfferPage';
import ThankYouPage from '../FinderApplicationPublicAccessEntrypoint/ThankYou';
import NotFoundPage from '../NotFoundPage';
import TestDriveJourney from '../TestDriveEntrypoint/Journey';
import CarListingPage from './CarListingPage';

export type FinderApplicationEntrypointProps = {
    endpoint: FinderApplicationEntrypointContextDataFragment;
};

const FinderApplicationEntrypoint = ({ endpoint }: FinderApplicationEntrypointProps) => {
    if (
        endpoint.finderApplicationModules.every(
            ({ permissions }) => !hasPermissions(permissions, [permissionKind.createApplication])
        )
    ) {
        return <NotFoundPage />;
    }

    return (
        <Routes>
            <Route key="list" element={<CarListingPage endpoint={endpoint} />} path="" />
            <Route key="finderRoot" element={<FinderApplicationProvider endpoint={endpoint} />} path=":listingId">
                <Route key="offer" element={<OfferPage endpoint={endpoint} />} index />
                <Route key="testdrive" element={<TestDriveJourney endpoint={endpoint} />} path="testdrive" />
                <Route key="apply" element={<Journey endpoint={endpoint} />} path="apply" />
                <Route key="thankyou" element={<ThankYouPage />} path="thankyou" />
                <Route key="404" element={<NotFoundPage />} path="*" />
            </Route>
            <Route key="404" element={<NotFoundPage />} path="*" />
        </Routes>
    );
};

export default withPrivateAccess(FinderApplicationEntrypoint);
